export default __webpack_public_path__ + "static/media/xameleon.67b18133.png";